import { Modal } from "amp-types/plp-slot";
import { AmpHeroBannerConfig, AmpInGridBannerConfig, AmpQuickFilterCarousel } from "./amplience";

export enum Brand {
  Very = "very",
  VeryIE = "veryireland",
  Littlewoods = "littlewoods",
}

export interface ActiveContent<T extends Record<string, unknown>> {
  position?: number;
  content: T;
}

export interface ActiveSlots {
  heroBanner?: ActiveContent<AmpHeroBannerConfig>[];
  quickFilter?: ActiveContent<AmpQuickFilterCarousel>[];
  inGridBanner?: ActiveContent<AmpInGridBannerConfig>[];
  modal?: ActiveContent<Modal>[];
}

export interface RelevantContent {
  position?: number;
  contentURL: string;
}

export interface RelevantSlots {
  [path: string]: Record<keyof ActiveSlots, RelevantContent[] | undefined> | undefined;
}
